export default __webpack_public_path__ + "static/media/top.0f0599fa.png";